/**
 * useFirebaseSave - Hook for immediate tournament save to Firestore
 * Used for critical actions like match validation / unvalidation
 */
import { useCallback } from 'react';
import { useTournament } from '../contexts/TournamentContext';
import { useAuth } from '../contexts/AuthContext';
import firebaseSyncService from '../services/firebaseSync';

const useFirebaseSave = () => {
  const { exportState } = useTournament();
  const { isSignedIn, getCurrentUser } = useAuth();

  const saveNow = useCallback(async () => {
    if (!isSignedIn() || !firebaseSyncService.currentTournamentId) return;
    const user = getCurrentUser();
    if (!user) return;

    try {
      const state = exportState();
      await firebaseSyncService.saveTournament(state, user.email, 'validation-save');
      console.log('💾 Sauvegarde immédiate après validation');
    } catch (error) {
      console.error('❌ Erreur sauvegarde immédiate:', error);
    }
  }, [exportState, isSignedIn, getCurrentUser]);

  return { saveNow };
};

export default useFirebaseSave;
